import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";

import timezoneArray from "../../assets/testtimeZone.json";

@Component({
  selector: "app-timezone",
  templateUrl: "./timezone.component.html",
  styleUrls: ["./timezone.component.css"]
})
export class TimezoneComponent implements OnInit {
  timezoneList: any;
  keyword = "text";
  data: any = []; 

  constructor(private _restService: RestService) {}

  ngOnInit() {
    this.data = timezoneArray;
  }

  selectEvent(item: any) {
    console.log("Selected items ----->>", item);
    this._restService.selectedTimeZoneItem(item);
  } 
}
